<template>
<v-app id="inspire">
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
    <v-row  >

      <v-col md="12" lg="12" cols="12">
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Reservas {{negocio.negocio}}</h1>
        <br/>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su reserva se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su reserva se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su reserva se edito con éxito.
       </v-alert>
        <v-card>
          <v-card-title>

            <v-autocomplete
                v-model="idfiesta"
                :items="Fiestas"
                item-text="nombre"
                item-value="id"
                label="Escoge Fiesta"
                @change="damereservas"
                persistent-hint
                single-line
            ></v-autocomplete>

          </v-card-title>
          <v-card-text>

            <v-data-table
                :headers="headers"
                :items="Reservas"
                sort-by="Fecha"
                sort-desc
                class="elevation-1"
                :search="search"
                loading-text="Cargando... Por favor espere"

                style="background-color: #393E46;"
            >
              <template v-slot:top>
                <v-toolbar flat >
                  <v-toolbar-title>Reservas</v-toolbar-title>
                  <v-progress-circular
                      indeterminate
                      v-if="progr == true"
                      color="primary"
                  ></v-progress-circular>
                  <v-divider
                      class="mx-4"
                      inset
                      vertical
                  ></v-divider>
                  <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Reserva</v-btn>
                    </template>
                    <v-card color="#393E46">
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row >
                            <v-col cols="12" sm="6" md="12">
                              <v-autocomplete
                                  v-model="editedItem.fiesta"
                                  :items="Fiestas"
                                  item-text="nombre"
                                  label="Escoge Fiesta"
                                  persistent-hint
                                  return-object
                                  single-line
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                              <v-autocomplete
                                  v-model="idzona"
                                  :items="Zonas"
                                  item-text="zona"
                                  item-value="id"
                                  label="Escoge Zona"
                                  @change="damemesas"

                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                              <v-autocomplete
                                  v-model="editedItem.espacioNegocio"
                                  :items="Mesas"
                                  item-text="espacio"
                                  label="Escoge Mesa / Box"
                                  persistent-hint
                                  return-object
                                  single-line
                              ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                              <v-text-field v-model="editedItem.reserva" label="Nombre de Reserva"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                              <v-text-field type="number" v-model="editedItem.cantPersonas" label="Cantidad de Personas"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                              <v-text-field v-model="editedItem.observaciones" label="Observaciones"></v-text-field>
                            </v-col>
                          </v-row>

                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogdelete" persistent max-width="350">
                    <v-card color="#393E46">
                      <v-card-title class="headline">Desea eliminar esta reserva?</v-card-title>
                      <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="close">No</v-btn>
                        <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.link`]="{item}">
              https://tunay.app/lista/reserva/{{item.codigoUnico}}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    color="blue"
                    class="mr-2"
                    @click="editItem(item)"
                >
                  fas fa-edit
                </v-icon>
                <v-icon
                    small
                    color="error"
                    class="mr-2"
                    @click="deleteItem(item)"
                >
                  fas fa-minus-circle
                </v-icon>
                <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'ListasR', params: { idreserva: item.idReserva }}"><v-icon
                    small
                    class="mr-2"

                    color="warning"
                >
                  fas fa-clipboard-list
                </v-icon></router-link>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="damereservas">Cargar de Nuevo</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import moment from "moment";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Reservas | Tunay Mi acceso de bolsillo',
  name:'Reservas',
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      idzona: 0,
      zonaid:0,
      progr: true,
      token:'',
      idmesa:0,
      alertborrador: false,
      abreviado:'NN',
      alertnuevo: false,
      alerteditar: false,
      overlay: false,
      zona:{},
      negocio:{
        activo: true,
        cantMinutos: 0,
        ciudad: {id: 129, ciudadNombre: "Lima"},
        cliente: {id: 4, clienteNombre: "Grupo Bros", logo: "", razonSocial: "", ruc: ""},
        direccion: "",
        facebook: "",
        horaApertura: "00:00:00",
        horaCierre: "00:00:00",
        icono: "",
        id: 23,
        impuesto: "",
        instagram: "",
        latitud: -3.7474129,
        logo: "",
        longitud: -73.2455166,
        mailreserva: "",
        moneda: {id: 1, moneda: "Soles", shortmoneda: "S/."},
        negocioNombre: "Noa",
        periocidad: {id: 8, periocidad: "anual", cantDias: 364},
        tag: "noa",
        tipoNegocio: {id: 2, tipoNegocio: "Discoteca"},
        website: ""
      },
      dialog: false,
      dialogdelete: false,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      Reservas: [],
      Fiestas: [],
      Mesas: [],
      Zonas: [],
      tiempos: [],
      search: '',
      idfiesta:0,
      editedIndex: -1,
      editedItem: {
        espacioNegocio:{} ,
        reserva : '',
        observaciones: '',
        fiesta: {},
        cantPersonas:10,
        cantMinutos:0,
        dateCreated: null
      },
      defaultItem: {
        espacioNegocio:{} ,
        reserva : '',
        observaciones: '',
        fiesta: {},
        cantPersonas:10,
        cantMinutos:0,
        dateCreated: null
    },
      headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Reserva', align: 'left',  value: 'reserva'},
        { text: 'Mesa', value: 'espacioNegocio.espacio' },
        { text: 'Zona', value: 'espacioNegocio.zonaNegocio.zona' },
        { text: 'Fiesta', value: 'fiesta.nombre' },
        { text: 'Link Reserva', value: 'link' },
      ]
  }),
  mounted (){
    this.idnegocio =  this.$route.params.idnegocio;
    this.editedItem.fechaReserva = this.formatDatee(this.date)
    this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
        if (this.usuario.id === undefined){
          this.overlay = true
          firebase
              .auth()
              .onAuthStateChanged(user => {
                if(user){
                  this.overlay = false
                  this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                  this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                  this.damereservas();
                  this.dameZonas();
                  this.damefiestas();

                }else{
                  this.overlay = false
                  this.$router.push({ path: '/' });
                }
              })


        }else{
          this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
          this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

          this.damefiestas();
        }

  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
         if (this.usuario.id === undefined){
           this.$router.push({ path: '/' });
                  }else{
           this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
           this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

           this.damereservas();
           this.dameZonas()
           this.damefiestas();        }
    },
  date () {
    this.editedItem.fechaReserva = this.formatDatee(this.date)
      },
  },
  methods : {
    formatDarete (date) {
      var fec = moment(date).locale('es-pe');
      return fec.tz(this.cliente.timeZone.timeZone).format("DD-MM-YYYY");
    },
    dametiempos(){
      let fechr = this.editedItem.fechaReserva
    let horaper = fechr+ " "+ this.negocio.horaApertura

      let horacr = fechr+ " "+ this.negocio.horaCierre
      let fechaapert = new Date(horaper)

      let fechacierre = new Date(horacr)
      let horap = fechaapert.getHours()  * 60
      let minap = fechaapert.getMinutes()
      var horcr
      if(fechacierre.getHours() >=0 && fechacierre.getHours() <=fechaapert.getHours() ){
         horcr = ( 24 + fechacierre.getHours()) * 60
      }else{
         horcr = fechacierre.getHours() * 60
      }

      let mincr = fechacierre.getMinutes()
      let totalminap = horap + minap
      let totalmincr = horcr + mincr
      var ap = ['AM', 'PM']; // AM-PM
      while (totalminap<totalmincr) {
        var hh = Math.floor(totalminap/60); // getting hours of day in 0-24 format
        var mm = (totalminap%60); // getting minutes of the hour in 0-55 format
        var tiempoampm
        if (hh%12 === 0){
           tiempoampm =  '12:' + ("0" + mm).slice(-2) + ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]

        }else{
           tiempoampm =  ("0" + (hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ap[Math.floor(hh/12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]

        }
        let tiempo24 = (hh) + ':' + ("0" + mm).slice(-2);
        let obj ={
          'tiempoampa' : tiempoampm,
          'tiempo24': tiempo24
        }

        this.tiempos.push(obj)
        totalminap = totalminap + this.negocio.cantMinutos;
      }
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatDaterese(value) {
      return moment(value).locale('es-pe').format("yyyy-MM-DD'T'HH:mm:ssZ")
    },

    formatDaters(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    format(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    damereservas(){
      this.overlay = true;

            let urlreserva = 'reservas/fiesta/' + this.idfiesta ;
        axios
        .get(urlreserva,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Reservas = response.data;
            this.overlay = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        this.overlay = false;
        });

    },
    damefiestas(){
      this.overlay = true;
      let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio ;
        axios
        .get(urlfiesta,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Fiestas = response.data;
            this.idfiesta = this.Fiestas[0].id
            this.overlay = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;


          this.dameZonas();
        })
        .catch((error)  => {
        console.log(error);
        this.overlay = false
        });
    },
     increment () {
      this.editedItem.precio = parseInt(this.editedItem.precio,10) + 1
    },
    decrement () {
      this.editedItem.precio = parseInt(this.editedItem.precio,10) - 1
    },
    damemesas(){


      this.progr = true;
            let urlemesa = 'espacios/negocio/zona/' + this.idzona ;
        axios
        .get(urlemesa,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.Mesas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        });
    },
    dameZonas(){
      this.overlay = true;
        axios
        .get('zonas/negocio/' + this.idnegocio ,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            console.log(response.data)
            this.Zonas = response.data;
            this.overlay = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          this.damereservas();
        })
        .catch((error)  => {
        console.log(error);
        this.overlay = false
        });
    },
    editItem (item) {
      this.editedIndex = this.Reservas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.damemesas();
      this.dialog = true
    },

    cambiaHoraR(){
      this.editedItem.horaReserva = this.editedItem.horaReserva.tiempo24
    },


    deleteItem (item) {
      this.editedIndex = this.Reservas.indexOf(item);
      this.dialogdelete = true;
    },
    borralo (){
      axios
      .delete('reserva',{
        data: {idReserva: this.Reservas[this.editedIndex].idReserva}
      },{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.damereservas();
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      var bodyFormData2 = new FormData();
      this.editedItem.fiesta.fechaInicio = this.formatDarete(new Date(this.editedItem.fiesta.fechaInicio+"T00:00:00"))
      this.editedItem.fiesta.fechaFinal = this.formatDarete(new Date(this.editedItem.fiesta.fechaFinal+"T00:00:00"))

      if (this.editedIndex > -1) {

        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
      .post('reservas/fiesta/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
                this.damereservas();
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      else {

        bodyFormData2.append("data",JSON.stringify(this.editedItem));
        axios
      .post('reservas/fiesta/editar',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                this.damereservas();
                this.alertnuevo = true;
                console.log(response);
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
      }
      this.editedItem = this.defaultItem
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva reserva' : 'Editar reserva'
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente:"cliente"
    })
  }
};
</script>
